export const mountUrlQueryParams = (
  url: string,
  params: Record<string, any>,
) => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key) =>
    searchParams.append(key, JSON.stringify(params[key])),
  );

  return url + '?' + String(searchParams);
};
